import {Component, Inject, Injector, OnInit} from '@angular/core';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {CategoryService} from '../services/category.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DialogData} from '../setting/setting.component';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.css']
})
export class AlertDialogComponent implements OnInit {
  public pomodoroRepository: PomodoroRepository;
  constructor(private injector: Injector,
              private categoryService: CategoryService,
              public dialogRef: MatDialogRef<AlertDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
  }
  deleteFromCategories(): any{
    this.pomodoroRepository.removeFromCategory(this.pomodoroRepository.getCategory);
    this.pomodoroRepository.save();
    this.dialogRef.close();
    this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe(
      (data) => {
      }
    );
  }
  closeDialog(): any{
    this.dialogRef.close();
  }
}
